import { forwardRef, type Ref, type ReactNode, type TextareaHTMLAttributes } from 'react';
import { InputWrapper, type InputWrapperBaseProps } from '../shared/InputBase.js';

export interface TextareaProps
  extends Omit<InputWrapperBaseProps, 'leftSection' | 'rightSection' | 'leftSectionWidth' | 'rightSectionWidth'>,
    Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size' | 'color'> {
  /** Minimum row height. */
  minRows?: number;
  /** Maximum row height before scroll. */
  maxRows?: number;
  autosize?: boolean;
}

export const Textarea = forwardRef(function Textarea(
  props: TextareaProps,
  ref: Ref<HTMLTextAreaElement>
): ReactNode {
  const {
    label, description, error, required, withAsterisk,
    size, className, style,
    id, minRows = 3, maxRows, autosize, rows,
    ...ta
  } = props;
  return (
    <InputWrapper
      label={label}
      description={description}
      error={error}
      required={required}
      withAsterisk={withAsterisk}
      size={size}
      className={className}
      style={style}
      inputId={id}
    >
      {({ inputId, describedBy, invalid, className: ctlClass }) => (
        <textarea
          ref={ref}
          id={inputId}
          rows={rows ?? minRows}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
          className={ctlClass}
          style={{
            resize: autosize ? 'none' : 'vertical',
            minHeight: autosize ? `calc(${minRows} * 1.5em + 20px)` : undefined,
            maxHeight: maxRows ? `calc(${maxRows} * 1.5em + 20px)` : undefined
          }}
          {...ta}
        />
      )}
    </InputWrapper>
  );
});
